import {cn} from "@bem-react/classname";

export const cnInput = cn('Input');